import React from "react";
import "../../page_content.css";

const VishwanathSport = () => {
  return (
    <div>
      <h1 className="title">Vishwanath Sport Meet</h1>
      <hr />
      <div className="page-content-gallery">
        <img
          src="/assets/images/Vishwnath Sports Meet/vsm_1.webp"
          alt="Award 1"
        />
        <img
          src="/assets/images/Vishwnath Sports Meet/vsm_2.webp"
          alt="Award 2"
        />
      </div>
      <p>
        Vishwanath Sports meet is the annual sports event of MIT ADT University;
        it is a gala event in which more than 4000 students from all over
        Maharashtra participate in various games to prove their metal as an
        athlete. The idea of Vishwanath Sports Meet emerged from a commitment to
        build the nation through sports which soon transformed into the motto of
        our sports meet. It is an event where young and talented athletes come
        together to fight fairly and showcase their athletic skills. MANET
        secured 2nd place out of 103 colleges in the year 2018, 1st place out of
        103 colleges in the year 2019 and 1st place out of 115 colleges in the
        year 2020.
      </p>

      <div id="page-links">
        <p>For More Information</p>
        <a
          href="https://vsm.mituniversity.ac.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button>Click Here</button>
        </a>
      </div>
    </div>
  );
};

export default VishwanathSport;
